import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPendingCourses,
  approveCourse,
} from "../../../redux/Actions/courseAdminActions";
import AdminNavbar from "./AdminNavbar";

const CourseAdminPending = () => {
  const dispatch = useDispatch();
  const [isLoadingAction, setIsLoadingAction] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    dispatch(fetchPendingCourses());
  }, [dispatch]);

  const { pendingCourses, loading, error } = useSelector(
    (state) => state.courseAdmin
  );

  const handleApproveCourse = (teacherCourseId) => {
    setIsLoadingAction(true);
    dispatch(approveCourse(teacherCourseId))
      .then(() => {
        setSuccessMessage("Course approved successfully!");
        dispatch(fetchPendingCourses());
        setIsLoadingAction(false);
      })
      .catch(() => {
        setErrorMessage("Error approving course. Please try again.");
        setIsLoadingAction(false);
      });
  };

  useEffect(() => {
    if (successMessage || errorMessage) {
      const timeout = setTimeout(() => {
        setSuccessMessage("");
        setErrorMessage("");
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [successMessage, errorMessage]);

  return (
    <div>
      <AdminNavbar />
      <Container>
        <Box sx={{ my: 4 }}>
          <Typography variant="h4" gutterBottom>
            Pending Courses
          </Typography>

          {loading && <Typography>Loading pending courses...</Typography>}
          {error && <Typography color="error">{error}</Typography>}

          {isLoadingAction && <CircularProgress />}
          {successMessage && <Alert severity="success">{successMessage}</Alert>}
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

          {pendingCourses && pendingCourses.length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Teacher Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Course Title
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Course Level
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Start Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingCourses.map((course) => (
                    <TableRow key={`pending-${course.teacherCourseId}`}>
                      <TableCell>{`${course.teacherFirstName} ${course.teacherLastName}`}</TableCell>
                      <TableCell>{course.courseTitle}</TableCell>
                      <TableCell>{course.courseLevel}</TableCell>
                      <TableCell>
                        {new Date(course.startDate).toLocaleDateString()}
                      </TableCell>
                      <TableCell>
                        {new Date(course.endDate).toLocaleDateString()}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleApproveCourse(course.teacherCourseId)
                          }
                          disabled={isLoadingAction}
                        >
                          {isLoadingAction ? "Processing..." : "Approve"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>No pending courses available</Typography>
          )}
        </Box>
      </Container>
    </div>
  );
};

export default CourseAdminPending;
